import React, { useCallback, useEffect, useMemo, useState } from "react";
import { array, string, bool, number } from "prop-types";
import checkIcon from "./assets/check.svg";
import errorIcon from "./assets/error.svg";
import infoIcon from "./assets/info.svg";
import warningIcon from "./assets/warning.svg";

import "./assets/Toast.css";

type ToastItem = {
  id: string | number;
  title?: string;
  description?: string;
  type?: string;
  icon?: string;
  backgroundColor?: string;
};

type ToastProps = {
  toastList: ToastItem[];
};

export const Toast = (props: ToastProps) => {
  const autoDelete = true;
  const dismissTime = 7000;
  const position = "top-right";
  // const { toastList, position, autoDelete, dismissTime } = props;
  const { toastList } = props;
  const [list, setList] = useState<ToastItem[]>([]);

  // Process toastList to add icons and background colors
  const processedToastList = useMemo(() => {
    return toastList.map((obj: ToastItem) => {
      const processedObj: ToastItem = { ...obj };
      switch (processedObj.type) {
        case "success":
          processedObj.icon = checkIcon;
          processedObj.backgroundColor = "#5cb85c";
          break;
        case "error":
          processedObj.icon = errorIcon;
          processedObj.backgroundColor = "#d9534f";
          break;
        case "info":
          processedObj.icon = infoIcon;
          processedObj.backgroundColor = "#5bc0de";
          break;
        case "warning":
          processedObj.icon = warningIcon;
          processedObj.backgroundColor = "#f0ad4e";
          break;
        default:
          processedObj.icon = checkIcon;
          processedObj.backgroundColor = "#5cb85c";
          break;
      }
      return processedObj;
    });
  }, [toastList]);

  // Update list when processedToastList changes
  useEffect(() => {
    setList(processedToastList);
  }, [processedToastList]);

  const deleteToast = useCallback(
    (id: string | number) => {
      const filteredList = list.filter((e) => e.id !== id);
      setList(filteredList);
    },
    [list],
  );

  useEffect(() => {
    const interval = setInterval(() => {
      if (autoDelete && toastList.length && list.length) {
        deleteToast(toastList[0].id);
      }
    }, dismissTime);

    return () => {
      clearInterval(interval);
    };
  }, [toastList, autoDelete, dismissTime, list, deleteToast]);

  // const deleteToast = id => {
  //   const listItemIndex = list.findIndex(e => e.id === id);
  //   const toastListItem = toastList.findIndex(e => e.id === id);
  //   list.splice(listItemIndex, 1);
  //   toastList.splice(toastListItem, 1);
  //   setList([...list]);
  // };

  return (
    <>
      <div className={`notification-container ${position}`}>
        {list.map((toast, i) => (
          <div
            key={i}
            className={`notification toast ${position}`}
            style={{
              backgroundColor: toast?.backgroundColor,
            }}
          >
            <button onClick={() => deleteToast(toast.id)}>X</button>
            <div className="notification-image">
              <img src={toast.icon} alt="" />
            </div>
            <div>
              <p className="notification-title">{toast.title}</p>
              <p className="notification-message">{toast.description}</p>
            </div>
          </div>
        ))}
      </div>
    </>
  );
};

Toast.propTypes = {
  toastList: array.isRequired,
  position: string,
  autoDelete: bool,
  dismissTime: number,
};

// export default Toast;
